import * as yup from 'yup';

import { isValidURL } from 'src/common/helpers';

export const createCompanyFormValidation = yup.object({
  name: yup.string().required('Company name is required.'),
  url: yup
    .string()
    .required('Company website is required.')
    .test('url-validation', 'Please enter a valid company website', (value) => isValidURL(value ?? '')),
});
